/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_CreatedInputs */

const en_coaching_created = /** @type {(inputs: Coaching_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session reserved.`)
};

const id_coaching_created = /** @type {(inputs: Coaching_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi dipesan.`)
};

/**
* | output |
* | --- |
* | "Session reserved." |
*
* @param {Coaching_CreatedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_created = /** @type {((inputs?: Coaching_CreatedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_CreatedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_created(inputs)
	return en_coaching_created(inputs)
});